import React                      from 'react'
import { Table }                  from 'antd'
import { Observer }               from 'mobx-react'

import { TEXT
       , tr }                     from '../00_assets'
import { kde_api_client_t
       }                          from '../02_api'
import { avoid_closing_modal
       , EditButtons
       , ModalPrompt
       , render_address
       , render_contact
       , TableState }             from '../10_ui'

import { ClientEditor
       , create_client_editor_model }          from './02_screen_clients_editor'



export const ClientsTable: React.FC<
   { clients: kde_api_client_t[]
   , onDelete: ( user: kde_api_client_t ) => any
   , onEdit: ( user: kde_api_client_t, new_values: Partial< kde_api_client_t > ) => any
   , loading: boolean
   } > = ( props ) =>
{
  const table_state = TableState( ) ;

  return <Observer render={ ( ) =>
  { 
    const row_key = ( row: kde_api_client_t ) => row.id + ''
        , on_edit = ( row: kde_api_client_t ) =>
          {
            const editor_model = create_client_editor_model( row ) ;

            ModalPrompt( tr( TEXT.CLIENT_EDIT_TITLE )
                      , <ClientEditor form={ editor_model } />
                      , ( ) =>
                        {
                          if ( editor_model.has_errors( ) )
                               avoid_closing_modal( ) ;
                          else
                               props.onEdit( row, editor_model.fields( ) as any )
                        }
                      ) ;
          }
        , row_className = ( ) => "on-hover"
        , columns = [ { title: tr( TEXT.UI_NAME )
                      , ...table_state.sort_col( 'name'
                                               , (row: kde_api_client_t) => row.name )
                      , render: ( row: kde_api_client_t ) =>
                          <span>{ [ row.name, row.surnames ].join( ' ' ) }</span>
                      , width: '33%'
                      }
                    , { title: tr( TEXT.CLIENT_ADDRESS )
                      , key: 'address'
                      , render: render_address
                      }
                    , { title: tr( TEXT.CLIENT_CONTACT )
                      , key: 'contact'
                      , render: render_contact
                      }
                    , { title: ''
                    , key: 'action'
                    , render: ( row: kde_api_client_t ) =>
                          <EditButtons
                            row={ row }
                            onEdit={ on_edit }
                            onDelete={ props.onDelete }
                          />
                      , width: '95px'
                      }
                    ] ;


    return <React.Fragment>
              <Table
                className="m-3 shadow"
                loading={ props.loading }
                columns={ columns }
                dataSource={ props.clients }
                pagination={ false }
                rowKey={ row_key }
                rowClassName={ row_className }
                onChange={ table_state.on_table_change }
              />
          </React.Fragment> ;
  } }/>
}
